// removed by extract-text-webpack-plugin
module.exports = {"signInButton":"gV5Xb13Tjv256DS39hJvY"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/login/components/deviceGoogleLogin/DeviceGoogleLogin.scss
// module id = 661
// module chunks = 0